import React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import StarRating from '@components/UI/molecules/StarRating';
import type { ReviewedModalProps } from './review-modal.types';

const STAR_SIZE = '2.2em';

export const ReviewedModal = ({
  totalSatisfaction,
  audioQuality,
  reviewText,
  onClose,
}: ReviewedModalProps) => {
  const { t } = useTranslation('common');

  const displayReview = reviewText || t('modals.review.noReview');

  return (
    <div className="max-w-xl mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.review.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <div className="reviewed-content">
            <div className="mb-4">
              <h4 className="mb-8">1. {t('modals.review.totalSatisfaction')}</h4>
              <StarRating fontSize={STAR_SIZE} rating={totalSatisfaction} />
            </div>
            <div className="mb-4">
              <h4 className="mb-8">2. {t('modals.review.audioQuality')}</h4>
              <StarRating fontSize={STAR_SIZE} rating={audioQuality} />
            </div>
            <div>
              <h4 className="mb-8">3. {t('modals.review.review')}</h4>
              <p>{displayReview}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
